import React from 'react';

const LoginForm = ({ handleSubmit, error }) => {
  return (
    <div className="flex items-center justify-center mt-40">
        <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">Sign in</h2>
            <form onSubmit={handleSubmit}>
                <div className="mb-4">
                    <label className="block text-gray-600 font-medium mb-2" htmlFor="login">
                        Login
                    </label>
                    <input
                        type="text"
                        id="login"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter your login"
                        required
                    />
                </div>
                <div className="mb-6">
                    <label className="block text-gray-600 font-medium mb-2" htmlFor="password">
                        Password
                    </label>
                    <input
                        type="password"
                        id="password"
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Enter your password"
                        required
                    />
                </div>

                {/* Error Message */}
                {error && (
                    <p className="text-red-500 text-sm my-3">{error}</p>
                )}

                <button
                    type="submit"
                    className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                    Log In
                </button>
            </form>
        </div>
    </div>
  );
};

export default LoginForm;
